import { Layout } from 'antd'
import { Content, Header } from 'antd/es/layout/layout'
import Availabilities from './id/Availabilities'

export const AvailabiltiesScreen = () => {
  return (
    <Layout>
      <Header style={{ borderBottom: '1px solid #2D2C3C' }}></Header>
      <Content>
        <Availabilities></Availabilities>
      </Content>
    </Layout>
  )
}
